import * as React from 'react';
import clsx from 'clsx';
import { CircleAlert } from 'lucide-react';
import { makeId } from '../../../utils';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper/SrOnly/SrOnly';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Radio = /*#__PURE__*/React.forwardRef(Radio_withRef);
function Radio_withRef({
  id,
  name,
  value,
  defaultChecked,
  checked,
  disabled,
  readOnly,
  invalid,
  className,
  children,
  variant = 'default',
  hint,
  error,
  inputProps,
  onChange,
  onFocus,
  onBlur,
  ...extraProps
}, ref) {
  const genId = React.useId();
  const inputId = id || makeId('radio', genId);
  const hintId = makeId(inputId, 'hint');
  const errorId = makeId(inputId, 'error');
  return /*#__PURE__*/_jsxs(Base, {
    className: clsx('Radio', {
      'Radio--invalid': invalid
    }, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx("input", {
      ref: ref,
      type: "radio",
      id: inputId,
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      checked: checked,
      disabled: disabled,
      readOnly: readOnly,
      "aria-describedby": clsx({
        [hintId]: hint,
        [errorId]: error
      }),
      className: "Radio-input",
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur,
      ...inputProps
    }), /*#__PURE__*/_jsx(Base, {
      tagName: "label",
      className: "Radio-label",
      htmlFor: inputId,
      children: variant === 'compact' ? /*#__PURE__*/_jsx(SrOnly, {
        children: children
      }) : children
    }), hint ? /*#__PURE__*/_jsx("div", {
      id: hintId,
      className: "Radio-hint",
      children: hint
    }) : null, error ? /*#__PURE__*/_jsxs("div", {
      id: errorId,
      className: "Radio-error",
      children: [/*#__PURE__*/_jsx(CircleAlert, {}), error]
    }) : null]
  });
}
Radio.displayName = 'Radio';
export { Radio };